import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import Accordion from 'components/Layout/Accordion';
import LoadingZone from 'components/LoadingZone';
import useProfileData from 'utils/hooks/useProfileData';
import BetaTag from 'components/Layout/BetaTag';
import PreviousLocationContext from 'utils/PreviousLocationContext';
import EventCard from './EventCard';
import MyEventsSkeleton from './MyEventsSkeleton';
import MultiLevelEventCard from './MultiLevelEventCard';

/**
 * Displays a list of events the user has registered for.
 */
const MyEvents = () => {
  const aEvents = useSelector(
    (state) => state.Profile?.EVENT_REGISTRATIONS || []
  );
  const bIsProfileDataLoading = useProfileData();
  const { oPreviousLocation } = useContext(PreviousLocationContext);
  return (
    <Accordion
      mTitle={
        <>
          <span>My Events</span>
          <span>{aEvents.length}</span>
          <BetaTag />
        </>
      }
      sTitleIcon='mapWithMarker'
      bStartOpen={oPreviousLocation?.pathname.includes('events')}
    >
      <LoadingZone
        isLoading={bIsProfileDataLoading}
        skeleton={<MyEventsSkeleton />}
      >
        <div className='myEvents__content'>
          {aEvents.length > 0 ? (
            <div className='myEvents__listWrapper'>
              <ul className='myEvents__list'>
                {aEvents.map((oEvent) =>
                  !oEvent?.SUB_EVENTS ? (
                    <EventCard oEvent={oEvent} key={oEvent.EVENT_ID} />
                  ) : (
                    <MultiLevelEventCard
                      oEvent={oEvent}
                      key={oEvent.EVENT_ID}
                    />
                  )
                )}
              </ul>
            </div>
          ) : (
            <p className='myEvents__none'>
              You are not currently registered for any upcoming events.
            </p>
          )}
          <p className='t-paragraph--small'>
            This may not be a comprehensive list of all Wake Forest events.
          </p>
        </div>
      </LoadingZone>
    </Accordion>
  );
};

export default MyEvents;
